export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=403908c362b5f2b3a61c913bc164550e867e39cb8f&name=revalidateCommunity!'